import { render } from "./VideoPlayer.vue?vue&type=template&id=037a08e2"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=037a08e2&lang=postcss"
script.render = render

export default script